var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.printMode
        ? [
            _c(
              "a-card",
              { attrs: { bordered: false, title: "资产报表" } },
              [
                _c(
                  "a-tabs",
                  {
                    on: { change: _vm.onTabChange },
                    model: {
                      value: _vm.activeTab,
                      callback: function ($$v) {
                        _vm.activeTab = $$v
                      },
                      expression: "activeTab",
                    },
                  },
                  [
                    _c(
                      "a-tab-pane",
                      { key: "dep", attrs: { tab: "折旧明细表" } },
                      [
                        _c(
                          "a-form",
                          {
                            staticStyle: { "margin-bottom": "12px" },
                            attrs: { layout: "inline" },
                          },
                          [
                            _c(
                              "a-form-item",
                              { attrs: { label: "期间起" } },
                              [
                                _c("a-month-picker", {
                                  attrs: { format: "YYYY-MM" },
                                  model: {
                                    value: _vm.depQuery.begin,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.depQuery, "begin", $$v)
                                    },
                                    expression: "depQuery.begin",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              { attrs: { label: "期间止" } },
                              [
                                _c("a-month-picker", {
                                  attrs: { format: "YYYY-MM" },
                                  model: {
                                    value: _vm.depQuery.end,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.depQuery, "end", $$v)
                                    },
                                    expression: "depQuery.end",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              { attrs: { label: "资产类别" } },
                              [
                                _c(
                                  "a-select",
                                  {
                                    staticStyle: { width: "140px" },
                                    attrs: {
                                      placeholder: "全部",
                                      "allow-clear": "",
                                    },
                                    model: {
                                      value: _vm.depQuery.categoryId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.depQuery,
                                          "categoryId",
                                          $$v
                                        )
                                      },
                                      expression: "depQuery.categoryId",
                                    },
                                  },
                                  _vm._l(_vm.categoryOptions, function (c) {
                                    return _c(
                                      "a-select-option",
                                      { key: c.id, attrs: { value: c.id } },
                                      [_vm._v(_vm._s(c.name))]
                                    )
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              { attrs: { label: "部门" } },
                              [
                                _c("a-tree-select", {
                                  staticStyle: { width: "150px" },
                                  attrs: {
                                    "allow-clear": "",
                                    treeDefaultExpandAll: "",
                                    dropdownStyle: {
                                      maxHeight: "240px",
                                      overflow: "auto",
                                    },
                                    treeData: _vm.orgTree,
                                    placeholder: "全部",
                                  },
                                  model: {
                                    value: _vm.depQuery.departmentId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.depQuery,
                                        "departmentId",
                                        $$v
                                      )
                                    },
                                    expression: "depQuery.departmentId",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              { attrs: { label: "资产编码" } },
                              [
                                _c("a-input", {
                                  staticStyle: { width: "130px" },
                                  attrs: { "allow-clear": "" },
                                  model: {
                                    value: _vm.depQuery.assetCode,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.depQuery, "assetCode", $$v)
                                    },
                                    expression: "depQuery.assetCode",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary", icon: "search" },
                                    on: { click: _vm.loadDep },
                                  },
                                  [_vm._v("查询")]
                                ),
                                _c(
                                  "a-button",
                                  {
                                    staticStyle: { "margin-left": "8px" },
                                    attrs: { icon: "download" },
                                    on: { click: _vm.exportDep },
                                  },
                                  [_vm._v("导出")]
                                ),
                                _c(
                                  "a-button",
                                  {
                                    staticStyle: { "margin-left": "8px" },
                                    attrs: { icon: "printer" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handlePrintReport(
                                          "ASSET_DEP_DETAIL",
                                          "折旧明细表",
                                          _vm.buildDepPrintData,
                                          {
                                            rows: _vm.depRows,
                                            summary: _vm.depSummary,
                                          }
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("打印")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-table",
                          {
                            attrs: {
                              bordered: "",
                              size: "middle",
                              rowKey: "id",
                              columns: _vm.depColumns,
                              dataSource: _vm.depRows,
                              loading: _vm.depLoading,
                              pagination: _vm.depPage,
                              scroll: _vm.tableScroll,
                            },
                            on: {
                              change: (p) =>
                                _vm.onPage(p, _vm.depPage, _vm.loadDep),
                            },
                          },
                          [
                            _c("template", { slot: "footer" }, [
                              _vm._v(
                                "\n            合计本期折旧：" +
                                  _vm._s(
                                    _vm.depSummary.depreciationAmount == null
                                      ? "***"
                                      : _vm.depSummary.depreciationAmount
                                  ) +
                                  "\n          "
                              ),
                            ]),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-tab-pane",
                      { key: "ledger", attrs: { tab: "资产台账" } },
                      [
                        _c(
                          "a-form",
                          {
                            staticStyle: { "margin-bottom": "12px" },
                            attrs: { layout: "inline" },
                          },
                          [
                            _c(
                              "a-form-item",
                              { attrs: { label: "资产类别" } },
                              [
                                _c(
                                  "a-select",
                                  {
                                    staticStyle: { width: "140px" },
                                    attrs: {
                                      placeholder: "全部",
                                      "allow-clear": "",
                                    },
                                    model: {
                                      value: _vm.ledgerQuery.categoryId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ledgerQuery,
                                          "categoryId",
                                          $$v
                                        )
                                      },
                                      expression: "ledgerQuery.categoryId",
                                    },
                                  },
                                  _vm._l(_vm.categoryOptions, function (c) {
                                    return _c(
                                      "a-select-option",
                                      { key: c.id, attrs: { value: c.id } },
                                      [_vm._v(_vm._s(c.name))]
                                    )
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              { attrs: { label: "部门" } },
                              [
                                _c("a-tree-select", {
                                  staticStyle: { width: "150px" },
                                  attrs: {
                                    "allow-clear": "",
                                    treeDefaultExpandAll: "",
                                    dropdownStyle: {
                                      maxHeight: "240px",
                                      overflow: "auto",
                                    },
                                    treeData: _vm.orgTree,
                                    placeholder: "全部",
                                  },
                                  model: {
                                    value: _vm.ledgerQuery.departmentId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.ledgerQuery,
                                        "departmentId",
                                        $$v
                                      )
                                    },
                                    expression: "ledgerQuery.departmentId",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              { attrs: { label: "状态" } },
                              [
                                _c(
                                  "a-select",
                                  {
                                    staticStyle: { width: "100px" },
                                    attrs: {
                                      placeholder: "全部",
                                      "allow-clear": "",
                                    },
                                    model: {
                                      value: _vm.ledgerQuery.status,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ledgerQuery, "status", $$v)
                                      },
                                      expression: "ledgerQuery.status",
                                    },
                                  },
                                  [
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "在用" } },
                                      [_vm._v("在用")]
                                    ),
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "闲置" } },
                                      [_vm._v("闲置")]
                                    ),
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "已处置" } },
                                      [_vm._v("已处置")]
                                    ),
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "已报废" } },
                                      [_vm._v("已报废")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              { attrs: { label: "期间起" } },
                              [
                                _c("a-month-picker", {
                                  attrs: { format: "YYYY-MM" },
                                  model: {
                                    value: _vm.ledgerQuery.begin,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ledgerQuery, "begin", $$v)
                                    },
                                    expression: "ledgerQuery.begin",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              { attrs: { label: "期间止" } },
                              [
                                _c("a-month-picker", {
                                  attrs: { format: "YYYY-MM" },
                                  model: {
                                    value: _vm.ledgerQuery.end,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ledgerQuery, "end", $$v)
                                    },
                                    expression: "ledgerQuery.end",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary", icon: "search" },
                                    on: { click: _vm.loadLedger },
                                  },
                                  [_vm._v("查询")]
                                ),
                                _c(
                                  "a-button",
                                  {
                                    staticStyle: { "margin-left": "8px" },
                                    attrs: { icon: "download" },
                                    on: { click: _vm.exportLedger },
                                  },
                                  [_vm._v("导出")]
                                ),
                                _c(
                                  "a-button",
                                  {
                                    staticStyle: { "margin-left": "8px" },
                                    attrs: { icon: "printer" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handlePrintReport(
                                          "ASSET_LEDGER",
                                          "资产台账",
                                          _vm.buildLedgerPrintData,
                                          {
                                            rows: _vm.ledgerRows,
                                            summary: _vm.ledgerSummary,
                                          }
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("打印")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-table",
                          {
                            attrs: {
                              bordered: "",
                              size: "middle",
                              rowKey: "id",
                              columns: _vm.ledgerColumns,
                              dataSource: _vm.ledgerRows,
                              loading: _vm.ledgerLoading,
                              pagination: _vm.ledgerPage,
                              scroll: _vm.tableScroll,
                            },
                            on: {
                              change: (p) =>
                                _vm.onPage(p, _vm.ledgerPage, _vm.loadLedger),
                            },
                          },
                          [
                            _c("template", { slot: "footer" }, [
                              _vm._v(
                                "\n            合计原值：" +
                                  _vm._s(
                                    _vm.ledgerSummary.originalValue == null
                                      ? "***"
                                      : _vm.ledgerSummary.originalValue
                                  ) +
                                  "\n          "
                              ),
                            ]),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-tab-pane",
                      { key: "change", attrs: { tab: "变动汇总表" } },
                      [
                        _c(
                          "a-form",
                          {
                            staticStyle: { "margin-bottom": "12px" },
                            attrs: { layout: "inline" },
                          },
                          [
                            _c(
                              "a-form-item",
                              { attrs: { label: "单据日期" } },
                              [
                                _c("a-range-picker", {
                                  attrs: { format: "YYYY-MM-DD" },
                                  on: { change: _vm.onChangeDateRange },
                                  model: {
                                    value: _vm.changeQuery.dateRange,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.changeQuery,
                                        "dateRange",
                                        $$v
                                      )
                                    },
                                    expression: "changeQuery.dateRange",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              { attrs: { label: "变动类型" } },
                              [
                                _c(
                                  "a-select",
                                  {
                                    staticStyle: { width: "120px" },
                                    attrs: {
                                      placeholder: "全部",
                                      "allow-clear": "",
                                    },
                                    model: {
                                      value: _vm.changeQuery.changeType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.changeQuery,
                                          "changeType",
                                          $$v
                                        )
                                      },
                                      expression: "changeQuery.changeType",
                                    },
                                  },
                                  _vm._l(_vm.changeTypes, function (t) {
                                    return _c(
                                      "a-select-option",
                                      { key: t, attrs: { value: t } },
                                      [_vm._v(_vm._s(t))]
                                    )
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary", icon: "search" },
                                    on: { click: _vm.loadChange },
                                  },
                                  [_vm._v("查询")]
                                ),
                                _c(
                                  "a-button",
                                  {
                                    staticStyle: { "margin-left": "8px" },
                                    attrs: { icon: "download" },
                                    on: { click: _vm.exportChange },
                                  },
                                  [_vm._v("导出")]
                                ),
                                _c(
                                  "a-button",
                                  {
                                    staticStyle: { "margin-left": "8px" },
                                    attrs: { icon: "printer" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handlePrintReport(
                                          "ASSET_CHANGE_SUMMARY",
                                          "变动汇总表",
                                          _vm.buildChangePrintData,
                                          { rows: _vm.changeRows }
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("打印")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("a-table", {
                          attrs: {
                            bordered: "",
                            size: "middle",
                            rowKey: "id",
                            columns: _vm.changeColumns,
                            dataSource: _vm.changeRows,
                            loading: _vm.changeLoading,
                            pagination: _vm.changePage,
                            scroll: _vm.tableScroll,
                          },
                          on: {
                            change: (p) =>
                              _vm.onPage(p, _vm.changePage, _vm.loadChange),
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "billTime",
                                fn: function (text) {
                                  return _c("span", {}, [
                                    _vm._v(
                                      _vm._s(text ? text.substring(0, 10) : "")
                                    ),
                                  ])
                                },
                              },
                            ],
                            null,
                            false,
                            2719117358
                          ),
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-tab-pane",
                      { key: "idle", attrs: { tab: "闲置资产清单" } },
                      [
                        _c(
                          "a-form",
                          {
                            staticStyle: { "margin-bottom": "12px" },
                            attrs: { layout: "inline" },
                          },
                          [
                            _c(
                              "a-form-item",
                              { attrs: { label: "资产类别" } },
                              [
                                _c(
                                  "a-select",
                                  {
                                    staticStyle: { width: "140px" },
                                    attrs: {
                                      placeholder: "全部",
                                      "allow-clear": "",
                                    },
                                    model: {
                                      value: _vm.idleQuery.categoryId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.idleQuery,
                                          "categoryId",
                                          $$v
                                        )
                                      },
                                      expression: "idleQuery.categoryId",
                                    },
                                  },
                                  _vm._l(_vm.categoryOptions, function (c) {
                                    return _c(
                                      "a-select-option",
                                      { key: c.id, attrs: { value: c.id } },
                                      [_vm._v(_vm._s(c.name))]
                                    )
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              { attrs: { label: "部门" } },
                              [
                                _c("a-tree-select", {
                                  staticStyle: { width: "150px" },
                                  attrs: {
                                    "allow-clear": "",
                                    treeDefaultExpandAll: "",
                                    dropdownStyle: {
                                      maxHeight: "240px",
                                      overflow: "auto",
                                    },
                                    treeData: _vm.orgTree,
                                    placeholder: "全部",
                                  },
                                  model: {
                                    value: _vm.idleQuery.departmentId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.idleQuery,
                                        "departmentId",
                                        $$v
                                      )
                                    },
                                    expression: "idleQuery.departmentId",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              { attrs: { label: "闲置时长≥(月)" } },
                              [
                                _c("a-input-number", {
                                  staticStyle: { width: "120px" },
                                  attrs: { min: 0, precision: 0 },
                                  model: {
                                    value: _vm.idleQuery.idleMonths,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.idleQuery, "idleMonths", $$v)
                                    },
                                    expression: "idleQuery.idleMonths",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary", icon: "search" },
                                    on: { click: _vm.loadIdle },
                                  },
                                  [_vm._v("查询")]
                                ),
                                _c(
                                  "a-button",
                                  {
                                    staticStyle: { "margin-left": "8px" },
                                    attrs: { icon: "download" },
                                    on: { click: _vm.exportIdle },
                                  },
                                  [_vm._v("导出")]
                                ),
                                _c(
                                  "a-button",
                                  {
                                    staticStyle: { "margin-left": "8px" },
                                    attrs: { icon: "printer" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handlePrintReport(
                                          "ASSET_IDLE_LIST",
                                          "闲置资产清单",
                                          _vm.buildIdlePrintData,
                                          { rows: _vm.idleRows }
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("打印")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("a-table", {
                          attrs: {
                            bordered: "",
                            size: "middle",
                            rowKey: "id",
                            columns: _vm.idleColumns,
                            dataSource: _vm.idleRows,
                            loading: _vm.idleLoading,
                            pagination: _vm.idlePage,
                            scroll: _vm.tableScroll,
                          },
                          on: {
                            change: (p) =>
                              _vm.onPage(p, _vm.idlePage, _vm.loadIdle),
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-tab-pane",
                      { key: "bizfin", attrs: { tab: "业财对账表" } },
                      [
                        _c(
                          "a-form",
                          {
                            staticStyle: { "margin-bottom": "12px" },
                            attrs: { layout: "inline" },
                          },
                          [
                            _c(
                              "a-form-item",
                              { attrs: { label: "对账期间" } },
                              [
                                _c("a-month-picker", {
                                  attrs: { format: "YYYY-MM" },
                                  model: {
                                    value: _vm.bizfinQuery.month,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.bizfinQuery, "month", $$v)
                                    },
                                    expression: "bizfinQuery.month",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary", icon: "search" },
                                    on: { click: _vm.loadBizfin },
                                  },
                                  [_vm._v("查询")]
                                ),
                                _c(
                                  "a-button",
                                  {
                                    staticStyle: { "margin-left": "8px" },
                                    attrs: { icon: "download" },
                                    on: { click: _vm.exportBizfin },
                                  },
                                  [_vm._v("导出")]
                                ),
                                _c(
                                  "a-button",
                                  {
                                    staticStyle: { "margin-left": "8px" },
                                    attrs: { icon: "printer" },
                                    on: {
                                      click: function ($event) {
                                        _vm.handlePrintReport(
                                          "ASSET_BIZFIN_CHECK",
                                          "业财对账表",
                                          _vm.buildBizfinPrintData,
                                          {
                                            rows: _vm.bizfinRows,
                                            period: _vm.bizfinQuery.month
                                              ? _vm.bizfinQuery.month.format(
                                                  "YYYY-MM"
                                                )
                                              : "",
                                          }
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("打印")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.bizfinPendingTip
                          ? _c("a-alert", {
                              staticStyle: { "margin-bottom": "12px" },
                              attrs: {
                                type: "warning",
                                "show-icon": "",
                                message: _vm.bizfinPendingTip,
                                description:
                                  "以上单据已审核但尚未生成总账凭证，可能导致对账差异，请等待凭证扫描或检查 gledger 配置",
                              },
                            })
                          : _vm._e(),
                        _c("a-table", {
                          attrs: {
                            bordered: "",
                            size: "middle",
                            rowKey: "subjectCode",
                            columns: _vm.bizfinColumns,
                            dataSource: _vm.bizfinRows,
                            loading: _vm.bizfinLoading,
                            pagination: false,
                            scroll: _vm.tableScroll,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "diff",
                                fn: function (text) {
                                  return _c(
                                    "span",
                                    {
                                      style: {
                                        color: Number(text) !== 0 ? "red" : "",
                                      },
                                    },
                                    [_vm._v(_vm._s(text))]
                                  )
                                },
                              },
                            ],
                            null,
                            false,
                            2476109715
                          ),
                        }),
                        _vm.noVoucherAssets.length
                          ? _c(
                              "div",
                              { staticStyle: { "margin-top": "12px" } },
                              [
                                _c(
                                  "a-divider",
                                  { attrs: { orientation: "left" } },
                                  [_vm._v("无凭证资产（手工转固未选借贷科目）")]
                                ),
                                _c("a-table", {
                                  attrs: {
                                    bordered: "",
                                    size: "small",
                                    rowKey: "assetCode",
                                    columns: _vm.noVoucherColumns,
                                    dataSource: _vm.noVoucherAssets,
                                    pagination: false,
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "a-tab-pane",
                      { key: "tax", attrs: { tab: "税会差异调节表" } },
                      [
                        _c(
                          "a-form",
                          {
                            staticStyle: { "margin-bottom": "12px" },
                            attrs: { layout: "inline" },
                          },
                          [
                            _c(
                              "a-form-item",
                              { attrs: { label: "期间" } },
                              [
                                _c("a-month-picker", {
                                  attrs: { format: "YYYY-MM" },
                                  model: {
                                    value: _vm.taxQuery.month,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.taxQuery, "month", $$v)
                                    },
                                    expression: "taxQuery.month",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary", icon: "search" },
                                    on: { click: _vm.loadTax },
                                  },
                                  [_vm._v("查询")]
                                ),
                                _c(
                                  "a-button",
                                  {
                                    staticStyle: { "margin-left": "8px" },
                                    attrs: { icon: "download" },
                                    on: { click: _vm.exportTax },
                                  },
                                  [_vm._v("导出")]
                                ),
                                _c(
                                  "a-button",
                                  {
                                    staticStyle: { "margin-left": "8px" },
                                    attrs: { icon: "printer" },
                                    on: {
                                      click: function ($event) {
                                        _vm.handlePrintReport(
                                          "ASSET_TAX_ADJUST",
                                          "税会差异调节表",
                                          _vm.buildTaxPrintData,
                                          {
                                            rows: _vm.taxRows,
                                            summary: _vm.taxSummary,
                                            period: _vm.taxQuery.month
                                              ? _vm.taxQuery.month.format(
                                                  "YYYY-MM"
                                                )
                                              : "",
                                          }
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("打印")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-table",
                          {
                            attrs: {
                              bordered: "",
                              size: "middle",
                              rowKey: "id",
                              columns: _vm.taxColumns,
                              dataSource: _vm.taxRows,
                              loading: _vm.taxLoading,
                              pagination: _vm.taxPage,
                              scroll: _vm.tableScroll,
                            },
                            on: {
                              change: (p) =>
                                _vm.onPage(p, _vm.taxPage, _vm.loadTax),
                            },
                          },
                          [
                            _c("template", { slot: "footer" }, [
                              _vm._v(
                                "\n            本期会计折旧：" +
                                  _vm._s(_vm.taxSummary.acctCurDep) +
                                  " / 本期税务折旧：" +
                                  _vm._s(_vm.taxSummary.taxCurDep) +
                                  " / 本期差异：" +
                                  _vm._s(_vm.taxSummary.curDiff) +
                                  "；\n            累计会计折旧：" +
                                  _vm._s(_vm.taxSummary.acctCumDep) +
                                  " / 累计税务折旧：" +
                                  _vm._s(_vm.taxSummary.taxCumDep) +
                                  " / 累计差异：" +
                                  _vm._s(_vm.taxSummary.cumDiff) +
                                  "\n          "
                              ),
                            ]),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-tab-pane",
                      { key: "supplier", attrs: { tab: "供应商往来对账" } },
                      [
                        _c(
                          "a-form",
                          {
                            staticStyle: { "margin-bottom": "12px" },
                            attrs: { layout: "inline" },
                          },
                          [
                            _c(
                              "a-form-item",
                              { attrs: { label: "供应商" } },
                              [
                                _c(
                                  "a-select",
                                  {
                                    staticStyle: { width: "180px" },
                                    attrs: {
                                      placeholder: "全部",
                                      "allow-clear": "",
                                      "show-search": "",
                                      "option-filter-prop": "children",
                                    },
                                    model: {
                                      value: _vm.supplierQuery.organId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.supplierQuery,
                                          "organId",
                                          $$v
                                        )
                                      },
                                      expression: "supplierQuery.organId",
                                    },
                                  },
                                  _vm._l(_vm.supList, function (s) {
                                    return _c(
                                      "a-select-option",
                                      { key: s.id, attrs: { value: s.id } },
                                      [_vm._v(_vm._s(s.supplier))]
                                    )
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              { attrs: { label: "对账日期" } },
                              [
                                _c("a-range-picker", {
                                  attrs: { format: "YYYY-MM-DD" },
                                  on: { change: _vm.onSupplierDateRange },
                                  model: {
                                    value: _vm.supplierQuery.dateRange,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.supplierQuery,
                                        "dateRange",
                                        $$v
                                      )
                                    },
                                    expression: "supplierQuery.dateRange",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary", icon: "search" },
                                    on: { click: _vm.loadSupplier },
                                  },
                                  [_vm._v("查询")]
                                ),
                                _c(
                                  "a-button",
                                  {
                                    staticStyle: { "margin-left": "8px" },
                                    attrs: { icon: "download" },
                                    on: { click: _vm.exportSupplier },
                                  },
                                  [_vm._v("导出")]
                                ),
                                _c(
                                  "a-button",
                                  {
                                    staticStyle: { "margin-left": "8px" },
                                    attrs: { icon: "printer" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handlePrintReport(
                                          "ASSET_SUPPLIER_STATEMENT",
                                          "供应商往来对账",
                                          _vm.buildSupplierPrintData,
                                          {
                                            rows: _vm.supplierRows,
                                            summary: _vm.supplierSummary,
                                          }
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("打印")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-table",
                          {
                            attrs: {
                              bordered: "",
                              size: "middle",
                              rowKey: "supplierId",
                              columns: _vm.supplierColumns,
                              dataSource: _vm.supplierRows,
                              loading: _vm.supplierLoading,
                              pagination: _vm.supplierPage,
                              scroll: _vm.tableScroll,
                            },
                            on: {
                              change: (p) =>
                                _vm.onPage(
                                  p,
                                  _vm.supplierPage,
                                  _vm.loadSupplier
                                ),
                            },
                          },
                          [
                            _c("template", { slot: "footer" }, [
                              _vm._v(
                                "\n            合计期末欠款：" +
                                  _vm._s(
                                    _vm.supplierSummary.endNeed == null
                                      ? "***"
                                      : _vm.supplierSummary.endNeed
                                  ) +
                                  "\n          "
                              ),
                            ]),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm.printMode
        ? [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "space-between",
                  "align-items": "center",
                  padding: "8px 16px",
                  background: "#fff",
                  "border-bottom": "1px solid #e8e8e8",
                  "margin-bottom": "12px",
                },
              },
              [
                _c(
                  "span",
                  {
                    staticStyle: { "font-size": "16px", "font-weight": "500" },
                  },
                  [_vm._v(_vm._s(_vm.printTitle))]
                ),
                _c(
                  "a-button",
                  {
                    attrs: { icon: "close" },
                    on: {
                      click: function ($event) {
                        _vm.printMode = false
                      },
                    },
                  },
                  [_vm._v("关闭")]
                ),
              ],
              1
            ),
            _c("ReportPrint", {
              attrs: {
                visible: true,
                tableData: _vm.printTableData,
                queryParam: {},
                billType: _vm.printBillType,
                billTypeName: _vm.printBillTypeName,
                buildData: _vm.printBuildData,
                embedded: true,
              },
              on: { "designer-change": _vm.onDesignerChange },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }